import { render, staticRenderFns } from "./OcActivo.vue?vue&type=template&id=19940bec"
import script from "./OcActivo.vue?vue&type=script&lang=js"
export * from "./OcActivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports